import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "./global/GlobalVars.js";
import * as language from "./utils/language.js";
import * as navigation from "./utils/navigation.js";

import homeImage from "./images/icons/Home.png";
import backImage from "./images/icons/Zurück.png";
import alarmOffImage from "./images/icons/AlarmOff.png";
import alarmOnImage from "./images/icons/AlarmOn.png";
import alarmBlinkImage from "./images/icons/Alarm.gif";
import forwardImage from "./images/icons/PfeilVor.png";
import backwardImage from "./images/icons/PfeilZurueck.png";
import logoImage from "./images/icons/Logo_Profax.png";
import MenuMobile from "./elements/System/MenuMobile.jsx";
import DateTime from "./elements/System/DateTime.jsx";

const HeaderMobile = observer((props) => {
  //========================================================================
  // Android-Zurück-Taste abfangen
  useEffect(() => {
    // Dummy-Eintrag pushen
    window.history.pushState({ page: "current" }, "");

    const handlePopState = (event) => {
      // Wird ausgelöst wenn Android Back gedrückt wird
      window.history.pushState({ page: "current" }, "");
      navigation.changePage("back");
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  //========================================================================
  // Textgröße je nach Länge
  const getFontSize = (text) => {
    const length = text.length;
    const size = Math.min(28, Math.max(5, 35 - 3.7 * Math.sqrt(length)));
    const val = `${size}px`;
    return val;
  };

  const title = language.displayText(
    globalVars.pageProperties.currentPageConfig.pageTitle,
  );

  //========================================================================
  // Anzahl Alarme
  let alarmCount = 0;

  try {
    alarmCount = globalVars.activeAlarms.length;
  } catch (error) {}

  //========================================================================
  // Button-Größe und Abstände
  const BTN = 58 * globalVars.scaleFactor;
  const TOP_ROW = 7 * globalVars.scaleFactor;
  const BTN_GAP = 7 * globalVars.scaleFactor;

  return (
    <div className="header">
      {/* ######################################################################################################## */}
      {/* ################################################ Header ################################################ */}
      {/* ######################################################################################################## */}
      <header
        style={{
          height: "110px",
          backgroundColor: "black",
          color: "white",
          userSelect: "none",
          touchAction: "none",
          overflow: "hidden",
        }}
      >
        {/* ######################################################################################################## */}
        {/* ################################################ Logo ################################################## */}
        {/* ######################################################################################################## */}
        {!(
          globalVars.pageProperties.showButtonNavigateBackward ||
          globalVars.pageProperties.showButtonNavigateForward
        ) && (
          <div
            style={{
              position: "absolute",
              left: "0px",
              top: TOP_ROW,
              width: "100%",
              height: BTN,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <img
              src={logoImage}
              style={{ maxHeight: BTN, width: BTN_GAP + 2 * BTN }}
              alt="Logo"
            />
          </div>
        )}
        {/* ######################################################################################################## */}
        {/* ################################################ Titel ################################################# */}
        {/* ######################################################################################################## */}
        <div
          style={{
            fontSize: getFontSize(title),
            position: "absolute",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            left: "0px",
            right: "0px",
            top: TOP_ROW + BTN,
            height: `calc(${110}px - ${TOP_ROW + BTN}px)`,
            pointerEvents: "none",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {language.displayText(
            globalVars.pageProperties.currentPageConfig.pageTitle,
          )}
        </div>
        <div>
          {/* ######################################################################################################## */}
          {/* ################################################ Button Menü ########################################### */}
          {/* ######################################################################################################## */}
          <div
            style={{
              position: "absolute",
              right: BTN_GAP,
              top: TOP_ROW,
              width: BTN,
              height: BTN,
            }}
          >
            <MenuMobile btn={BTN} />
          </div>
          {/* ######################################################################################################## */}
          {/* ################################################ Button Home ########################################### */}
          {/* ######################################################################################################## */}
          <button
            className="navButton"
            title={language.displayText([
              "Startseite",
              "pagina iniziale",
              "startpage",
            ])}
            onClick={() => navigation.changePage("home")}
            style={{
              position: "absolute",
              left: BTN_GAP + BTN + BTN_GAP,
              top: TOP_ROW,
              width: BTN,
              height: BTN,
              backgroundImage: `url(${homeImage})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></button>
          {/* ######################################################################################################## */}
          {/* ################################################ Button Zurück ######################################### */}
          {/* ######################################################################################################## */}
          <button
            className="navButton"
            title={language.displayText([
              "letzte Seite",
              "ultima pagina",
              "last page",
            ])}
            onClick={() => navigation.changePage("back")}
            style={{
              position: "absolute",
              right: BTN_GAP + (BTN + BTN_GAP) * 1,
              top: TOP_ROW,
              width: BTN,
              height: BTN,
              backgroundImage: `url(${backImage})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></button>
          {/* ######################################################################################################## */}
          {/* ################################################ Button Alarm ########################################## */}
          {/* ######################################################################################################## */}
          {!!globalVars.auth.alarm && (
            <div>
              <button
                className="navButton"
                style={{
                  position: "absolute",
                  left: BTN_GAP,
                  top: TOP_ROW,
                  width: BTN,
                  height: BTN,

                  backgroundImage: `url(${
                    globalVars.alarmActive === 1
                      ? alarmBlinkImage
                      : globalVars.alarmActive === 2
                        ? alarmOnImage
                        : alarmOffImage
                  })`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              ></button>
              <div
                style={{
                  position: "absolute",
                  left: BTN_GAP,
                  top: TOP_ROW,
                  width: BTN,
                  height: BTN,
                  color: "white",
                  backgroundColor: "transparent",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                {alarmCount}
              </div>
              <button
                className="navButton"
                title={language.displayText(["Alarme", "allarmi", "alarms"])}
                onClick={() => navigation.changePage("alarmMobile")}
                style={{
                  position: "absolute",
                  left: BTN_GAP,
                  top: TOP_ROW,
                  width: BTN,
                  height: BTN,
                  opacity: "0",
                }}
              ></button>
            </div>
          )}
          {/* ######################################################################################################## */}
          {/* ################################################ Button Vorwärts ####################################### */}
          {/* ######################################################################################################## */}
          {globalVars.pageProperties.showButtonNavigateForward && (
            <button
              className="navButton"
              title={language.displayText([
                "Seite vor",
                "pagina successiva",
                "page before",
              ])}
              onClick={() => navigation.changePage("forward")}
              style={{
                position: "absolute",
                right: BTN_GAP + (BTN + BTN_GAP) * 2,
                top: TOP_ROW,
                width: BTN,
                height: BTN,
                backgroundImage: `url(${forwardImage})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            ></button>
          )}
          {/* ######################################################################################################## */}
          {/* ################################################ Button Rückwärts ###################################### */}
          {/* ######################################################################################################## */}
          {globalVars.pageProperties.showButtonNavigateBackward && (
            <button
              className="navButton"
              title={language.displayText([
                "Seite zurück",
                "pagina precedente",
                "page back",
              ])}
              onClick={() => navigation.changePage("backward")}
              style={{
                position: "absolute",
                left: BTN_GAP + (BTN + BTN_GAP) * 2,
                top: TOP_ROW,
                width: BTN,
                height: BTN,
                backgroundImage: `url(${backwardImage})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            ></button>
          )}

          {/* ######################################################################################################## */}
          {/* ################################################ Uhrzeit und Datum ##################################### */}
          {/* ######################################################################################################## */}
          {false && <DateTime left={BTN_GAP} top={"203px"} />}
        </div>
      </header>
    </div>
  );
});

export default HeaderMobile;
